import ModalContainer from '@/components/molecules/ModalContainer/ModalContainer';
import {
  ORGANIZATION_CONTRACT_SERVICE_COST_BASIS_UNITS_DISPLAY_LABELS,
  ORGANIZATION_CONTRACT_SERVICE_TYPES_DISPLAY_LABELS,
} from '@/constants/stringVars';
import { TContractServiceBE } from '@/types/Organization.types';
import React, { Dispatch, SetStateAction } from 'react';
import useEditContractServiceTotal from '@/hooks/contracts/useEditContractServiceTotal';
import ContractServiceEditModalBody from './ContractServiceEditModalBody';

interface Props {
  contractId: string;
  amountEditingService: TContractServiceBE | undefined;
  setAmountEditingService: Dispatch<SetStateAction<TContractServiceBE | undefined>>;
  onEditSuccessful?: () => void;
}

const ContractServiceEditTotalModal = ({
  contractId,
  amountEditingService,
  setAmountEditingService,
  onEditSuccessful,
}: Props) => {
  const onClose = () => setAmountEditingService(undefined);

  const { mutate, isPending, isError } = useEditContractServiceTotal(() => {
    onClose();
    onEditSuccessful?.();
  });

  const onSubmit = ({ newAmount }: { newAmount: number }) => {
    if (amountEditingService) {
      mutate({
        contractId,
        changeAmount: newAmount,
        editedContractServiceType: amountEditingService.type,
      });
    }
  };

  return (
    <ModalContainer isOpen={!!amountEditingService} onClose={onClose} title="Edit Total Amount">
      {amountEditingService ? (
        <ContractServiceEditModalBody
          amountEditLabel="total"
          serviceType={ORGANIZATION_CONTRACT_SERVICE_TYPES_DISPLAY_LABELS[amountEditingService!.type]}
          costBasisUnit={
            ORGANIZATION_CONTRACT_SERVICE_COST_BASIS_UNITS_DISPLAY_LABELS[amountEditingService.costBasisUnit]
          }
          total={amountEditingService.total ?? 0}
          used={amountEditingService.used ?? 0}
          onClose={onClose}
          onSubmit={onSubmit}
          isSubmitPending={isPending}
          isSubmitError={isError}
        />
      ) : null}
    </ModalContainer>
  );
};

export default ContractServiceEditTotalModal;
